module.exports = __webpack_public_path__ + "static/media/nydi-hero.1ec86776.jpg";